export default __webpack_public_path__ + "static/doccam_b.a2497197e0632c5f1704e04888d1aa1f.png";